function evalArithmetic(expr: string): number {
  let pos = 0;

  function skipWs(): void {
    while (pos < expr.length && expr[pos] === ' ') pos++;
  }

  function parseExpr(): number {
    let left = parseTerm();
    skipWs();
    while (pos < expr.length && (expr[pos] === '+' || expr[pos] === '-')) {
      const op = expr[pos++];
      left = op === '+' ? left + parseTerm() : left - parseTerm();
      skipWs();
    }
    return left;
  }

  function parseTerm(): number {
    let left = parseUnary();
    skipWs();
    while (pos < expr.length && (expr[pos] === '*' || expr[pos] === '/' || expr[pos] === '%')) {
      const op = expr[pos++];
      const right = parseUnary();
      if (op === '*') left *= right;
      else if (op === '/') left = right !== 0 ? left / right : NaN;
      else left %= right;
      skipWs();
    }
    return left;
  }

  function parseUnary(): number {
    skipWs();
    if (pos < expr.length && expr[pos] === '-') { pos++; return -parsePrimary(); }
    if (pos < expr.length && expr[pos] === '+') { pos++; }
    return parsePrimary();
  }

  function parsePrimary(): number {
    skipWs();
    if (pos < expr.length && expr[pos] === '(') {
      pos++;
      const val = parseExpr();
      skipWs();
      if (pos < expr.length && expr[pos] === ')') pos++;
      return val;
    }
    let numStr = '';
    while (pos < expr.length && /[0-9.]/.test(expr[pos])) numStr += expr[pos++];
    skipWs();
    return numStr ? parseFloat(numStr) : NaN;
  }

  return parseExpr();
}

export function evaluateCustomFormula(formula: string, values: Record<string, string>): string {
  const sortedNames = Object.keys(values).sort((a, b) => b.length - a.length);
  let expr = formula;

  for (const name of sortedNames) {
    const numVal = parseFloat(values[name]);
    if (!isNaN(numVal)) {
      const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      expr = expr.replace(new RegExp(`\\b${escapedName}\\b`, 'g'), String(numVal));
    }
  }

  if (/[A-Za-z_]/.test(expr)) return '';

  try {
    const result = evalArithmetic(expr.replace(/\s+/g, ''));
    return isFinite(result) ? result.toFixed(5) : '';
  } catch {
    return '';
  }
}